import React from "react"
import { Col, Container, Row, Table } from "reactstrap"

const OrderFulfillment = () => {
  const inventoryLevelTableData = [
    { productsku: "485622", productName: "Blue colored headphones", currentStock: 200, allocatedForOrders: 50, availableForNewOrders: 150 },
    { productsku: "485622", productName: "Blue colored headphones", currentStock: 200, allocatedForOrders: 50, availableForNewOrders: 150 },
    { productsku: "485622", productName: "Blue colored headphones", currentStock: 200, allocatedForOrders: 50, availableForNewOrders: 150 },
    { productsku: "485622", productName: "Blue colored headphones", currentStock: 200, allocatedForOrders: 50, availableForNewOrders: 150 },
    { productsku: "485622", productName: "Blue colored headphones", currentStock: 200, allocatedForOrders: 50, availableForNewOrders: 150 },
  ]

  const shippingCarrerTableData = [
    { carrier: "Mae-go", onTimeDelivery: 98, averageTransitTime: 2, damagedPackages: 0.5, lostPackages: 0.1 },
    { carrier: "Mae-go", onTimeDelivery: 98, averageTransitTime: 2, damagedPackages: 0.5, lostPackages: 0.1 },
    { carrier: "Mae-go", onTimeDelivery: 98, averageTransitTime: 2, damagedPackages: 0.5, lostPackages: 0.1 },
  ]

  return (
    <Container fluid style={{ background: "#f2f2f2", minHeight: "100vh", paddingBlock: "1rem" }}>
      <h4 className="fw-semibold">Order Fulfillment</h4>

      <Container fluid>
        <Row>
          <Col xs="12" lg='4' className=" d-grid">
            <h5>Overview</h5>
            <div className="rounded border border-black p-3 fw-medium bg-white">
              <Row className="g-0">
                <Col>Orders to be Fulfilled:</Col>
                <Col xs="1" style={{ color: "#EC7426" }}>
                  20
                </Col>
              </Row>
              <Row className="g-0">
                <Col>Orders in Transit:</Col>
                <Col xs="1" style={{ color: "#EC7426" }}>
                  15
                </Col>
              </Row>
              <Row className="g-0">
                <Col>Delivered Orders:</Col>
                <Col xs="1" style={{ color: "#EC7426" }}>
                  50
                </Col>
              </Row>
              <Row className="g-0">
                <Col>Returns Pending:</Col>
                <Col xs="1" style={{ color: "#EC7426" }}>
                  3
                </Col>
              </Row>
            </div>
          </Col>
          <Col xs='12' lg='8' className="flex-1 d-grid">
          <div className="bg-white">
            <h5>Alerts</h5>
            <div className="rounded border border-black p-3 ">
              <ul>
                <li>2 Orders delayed in transit</li>
                <li>Low stock alert for Product A</li>
              </ul>
            </div>
            </div>
          </Col>
        </Row>

        <Container fluid className="g-0 mt-3">
          <h5>Inventory Levels for Fulfillment</h5>

          <Container fluid className="g-0 p-3 bg-white rounded-3">
            <Table responsive>
              <thead>
                <tr style={{ background: "#F2F2F2" }}>
                  <th>Product SKU</th>
                  <th>Product Name</th>
                  <th>Current Stock</th>
                  <th>Allocated for Orders</th>
                  <th>Available for New Orders</th>
                </tr>
              </thead>
              <tbody>
                {inventoryLevelTableData.map((row) => (
                  <tr>
                    <td>{row.productsku}</td>
                    <td>{row.productName}</td>
                    <td>{row.currentStock}</td>
                    <td>{row.allocatedForOrders}</td>
                    <td>{row.availableForNewOrders}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Container>
        </Container>

        <Container fluid className="g-0 mt-3">
          <h5>Shipping Carrier Performance</h5>

          <Container fluid className="g-0 p-3 bg-white rounded-3">
            <Table responsive>
              <thead>
                <tr style={{ background: "#F2F2F2" }}>
                  <th>Carrier</th>
                  <th>On-Time Delivery (%)</th>
                  <th>Average Transit Time (days)</th>
                  <th>Damaged Packages (%)</th>
                  <th>Lost Packages (%)</th>
                </tr>
              </thead>
              <tbody>
                {shippingCarrerTableData.map((row) => (
                  <tr className="text-sm-sm">
                    <td>{row.carrier}</td>
                    <td>{row.onTimeDelivery}</td>
                    <td>{row.averageTransitTime}</td>
                    <td>{row.damagedPackages}</td>
                    <td>{row.lostPackages}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Container>
        </Container>
      </Container>
    </Container>
  )
}

export default OrderFulfillment
